export default "__VITE_ASSET__d9StDTaX__"